var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "bottom-bar" }, [
    !_vm.downloading && !_vm.interacting
      ? _c(
          "div",
          {
            staticClass: "bottom-bar__actions",
            style: `transform: scale(${_vm.controlsScale}); transform-origin: bottom left;`,
          },
          [
            !_vm.footerVisible
              ? _c("InfoButton", {
                  attrs: { size: _vm.buttonSize },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.showFooter(true)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }